<template>
  <tr>
    <td data-label="Name">
      <strong>
        {{ staff.fullName }}
        <em v-if="staff.AccountType.administrator">
          (admin)
        </em>
      </strong>
      <br />
      ({{ staff.username }})
    </td>
    <td data-label="Email">
      <a :href="'mailto:' + staff.email" target="_top">
        {{ staff.email }}
      </a>
    </td>
    <td data-label="Phone">
      <a :href="'tel:' + phone">
        {{ staff.phone }}
      </a>
    </td>
    <td class="text-center">
      <img
        v-for="app in staff.Applications"
        :key="app.uuid"
        class="nav-item-img my-1" 
        :src="app.AppIcon ? 'https://s3-ap-southeast-2.amazonaws.com/roscon/' + app.AppIcon.objectKey : ''" 
        alt="Roscon Admin" />
    </td>
    <td class="button-3 text-center">
      <router-link class="my-2 btn btn-primary" :to="'/live-feed?s=' + staff.uuid">
        <i class="fa fa-eye" /> Activity
      </router-link>
      <button class="my-2 btn btn-info" @click="generateStaffActivityStatement()">
        <i class="fa fa-sticky-note" /> Generate Statement
      </button>
      <button class="my-2 btn btn-primary" @click="editStaffActivityStatement()">
        <i class="fa fa-fw fa-copy" /> View Statements
      </button>
      <button class="my-2 btn btn-warning" @click="editStaffMember()">
        <i class="fa fa-edit" /> Edit
      </button>
      <button class="my-2 btn btn-danger" @click="deleteStaffMember()">
        <i class="fa fa-trash" /> Delete
      </button>
    </td>
  </tr>
</template>

<script>
import {
    GENERATE_ACTIVITY_STATEMENT,
    EDIT_ACTIVITY_STATEMENT
  } from '@/vuex/types'
export default {
  name: 'StaffRow',
  props: {
    object: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  computed: {
    phone () {
      if (this.staff.phone) {
        return this.staff.phone.replace(/\D/g, '')
      } else {
        return ''
      }
    },
    staff () {
      return {
        AccountType: {},
        ...this.object
      }
    }
  },
  methods: {
    editStaffMember () {
      this.$emit('edit', { permalink: 'editStaff', uuid: this.staff.uuid })
    },
    deleteStaffMember () {
      this.$emit('deleteObject', { permalink: 'deleteStaff', uuid: this.staff.uuid })
    },
    generateStaffActivityStatement () {
      this.$store.dispatch(GENERATE_ACTIVITY_STATEMENT, { uuid: this.staff.uuid })
    },
    editStaffActivityStatement () {
      this.$store.dispatch(EDIT_ACTIVITY_STATEMENT, { uuid: this.staff.uuid })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/rows/Staff.vue